import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import CardTemplate from "./template/CardTemplate";
import { formatTimestampInMap } from '../../../utils';

const CheckLists = ({list, accepted, handleAccepted, isApprove, approveDocumentDetails, type}) => {
    const isPersonalDocument = type === "personalDocument";
    const checkList = isPersonalDocument ? list?.personal_document_type_check_items : list?.document_type_check_items;
    const listDescription = isPersonalDocument ? list?.personal_document_type_check_list_description : list?.document_type_check_list_description;
    const documentCheckAt = isPersonalDocument ? approveDocumentDetails?.ftm_personal_document_check_check_at : approveDocumentDetails?.document_check_check_at;

    return(
        <CardTemplate 
            title={listDescription}
            isBoxShadow={true}
            headerTextAlign={"text-center"}
            spanTitle="Check list"
            isCenterTitle={true}
        >
            <>
                {checkList?.map((item, index) => (
                    <div className="d-flex justify-content-lg-start justify-content-center p-2" key={index}>
                        <i className="material-icons my-auto text-xs">circle</i>
                        <span className="text-sm ps-3">{isPersonalDocument ? item.personal_document_type_check_item_label : item.document_type_check_item_label}</span>
                    </div>
                ))}

                <div className='my-2'>
                    {isApprove ? (
                        <b>{`${approveDocumentDetails?.admin_user?.admin_full_name} approved this document at ${formatTimestampInMap(documentCheckAt)}.`}</b>
                    ) : (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={accepted}
                                    onChange={(e) => handleAccepted(e.target.checked)}
                                    color="success"
                                />
                            }
                            label={<b>I have reviewed every item on the checklist.</b>}
                        />
                    )}
                </div>
            </>
        </CardTemplate>
    );
};

export default CheckLists;